
import { Component, Vue } from "vue-property-decorator";
import Nav from "@/components/Nav.vue";
import Footerr from "@/components/Footerr.vue";

export default Vue.extend({
  name: "jobs",
  components: {
    Footerr,
    Nav,
  },
  data: () => ({
    jobs: [
      {
        id: 1,
        title: "Jobs.box1.title",
        icon1: "mdi-map-marker",
        icon2: "mdi-clock-time-five",
        titleKey1: "Jobs.box1.span1",
        titleKey2: "Jobs.box1.span2",
        description: "Jobs.box1.text",
        btnn: "Jobs.box1.btn",
      },
      {
        id: 2,
        title: "Jobs.box1.title",
        icon1: "mdi-map-marker",
        icon2: "mdi-clock-time-five",
        titleKey1: "Jobs.box1.span1",
        titleKey2: "Jobs.box1.span2",
        description: "Jobs.box1.text",
        btnn: "Jobs.box1.btn",
      },
      {
        id: 3,
        title: "Jobs.box1.title",
        icon1: "mdi-map-marker",
        icon2: "mdi-clock-time-five",
        titleKey1: "Jobs.box1.span1",
        titleKey2: "Jobs.box1.span2",
        description: "Jobs.box1.text",
        btnn: "Jobs.box1.btn",
      },
      {
        id: 4,
        title: "Jobs.box1.title",
        icon1: "mdi-map-marker",
        icon2: "mdi-clock-time-five",
        titleKey1: "Jobs.box1.span1",
        titleKey2: "Jobs.box1.span2",
        description: "Jobs.box1.text",
        btnn: "Jobs.box1.btn",
      },
    ],
  }),
});
